export function range(length: number): number[] {
  return Array.from(Array(length).keys());
}
